import { api } from "@/services/api"

import { Lead } from "../hooks/use-chat-store" // Assuming Lead interface is in use-chat-store

export const leadService = {
  async getLead(leadId: string): Promise<Lead> {
    if (!leadId) {
      throw new Error("Lead ID is required")
    }
    try {
      const response = await api.get(`/crm/leads/${leadId}`)
      return response.data as Lead
    } catch (error) {
      console.error(`Error fetching lead ${leadId}:`, error)
      throw error
    }
  },

  async findLeads(query: string): Promise<Lead[]> {
    try {
      const response = await api.get<Lead[]>(`/crm/leads`, {
        params: { search: query },
      })
      return response.data
    } catch (error) {
      console.error(`Error finding leads for query ${query}:`, error)
      return []
    }
  },

  async blockLead(leadId: string, reason: string): Promise<Lead> {
    if (!leadId) {
      throw new Error("Lead ID is required")
    }
    if (!reason) {
      throw new Error("Block reason is required")
    }
    try {
      const response = await api.post(`/crm/leads/${leadId}/block`, { reason })
      return response.data as Lead
    } catch (error) {
      console.error(`Error blocking lead ${leadId}:`, error)
      throw error
    }
  },

  async updateLeadTags(leadId: string, tags: string[]): Promise<Lead> {
    const response = await api.put(`/crm/leads/${leadId}`, { tags })
    return response.data as Lead
  },

  async updateLeadStatus(leadId: string, status: string): Promise<Lead> {
    const response = await api.put(`/crm/leads/${leadId}`, { status })
    return response.data as Lead
  },

  async updateLeadNotes(leadId: string, notes: string): Promise<Lead> {
    const response = await api.put(`/crm/leads/${leadId}`, { notes })
    return response.data as Lead
  },

  async updateLeadCustomAttributes(
    leadId: string,
    customAttributes: Record<string, string>
  ): Promise<Lead> {
    const response = await api.put(`/crm/leads/${leadId}`, {
      custom_attributes: customAttributes,
    })
    return response.data as Lead
  },

  async unblockLead(leadId: string): Promise<Lead> {
    if (!leadId) {
      throw new Error("Lead ID is required")
    }
    try {
      const response = await api.post(`/crm/leads/${leadId}/unblock`)
      return response.data as Lead
    } catch (error) {
      console.error(`Error unblocking lead ${leadId}:`, error)
      throw error
    }
  },
}
